<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Brand') }}</legend>
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <!--@todo logo-->

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('SEO') }}</legend>
                            <text-input label="meta_title" v-model="form.meta_title" :error="form.errors.meta_title" />
                            <textarea-input label="meta_description" v-model="form.meta_description" :error="form.errors.meta_description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col w-100">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Seiteninhalt') }}</legend>
                            <editor-input label="description" v-model="form.description" :error="form.errors.description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="brand">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import EditorInput from '@/shared/Inputs/EditorInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'brand',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            EditorInput,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.brands.destroy', this.brand));
            },

        },
    }
</script>
